export default {
  background: '#fff',
  foreground: '#000',
  flavor: ['#000'],
  cardColor: '#fff',
  backgroundColor: '#E5E5E5',
  buttonColor: '#548594',
  navigationColor: '#fff',
}
